@if (useDedicatedIcon()) {
  <img src="/icons/{{ notification().type | replaceChar: '_' : '-' }}.png" alt=""/>
} @else {
  <i class="pi pi-bell" style="font-size: 1.5rem"></i>
}

<div class="notify-content">
  <div class="title">{{ notification().title }}</div>
  <div class="message">{{ notification().description }}</div>
  <div class="date">{{ notification().createdAt | timeFromNow }}</div>
</div>

<div class="notify-actions">
  @if (notification().readAt === null) {
    <div class="status-dot unread"></div>
  }
</div>
